import { Badge } from "@chakra-ui/react";
import { BrandLogo, ModuleTitle } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import type { Brand } from "@src/__generated__/graphql";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import type { DeepPick } from "ts-essentials";

interface BrandTitleProps {
  brand: {
    name: Brand["name"];
    code: Brand["code"];
    numeric_code?: Brand["numeric_code"];
    archived_at?: Brand["archived_at"];
    image?: DeepPick<
      Brand["image"],
      {
        urls: {
          thumbnail: never;
        };
      }
    >;
  };
}

const BrandTitle = ({ brand }: BrandTitleProps) => {
  const { workspaceStore } = useStore();

  return (
    <div className="flex items-center my-1">
      <div className="mr-6">
        <BrandLogo src={brand.image?.urls.thumbnail} />
      </div>
      <ModuleTitle
        text={`${brand.name} (${brand.code})${workspaceStore.settings?.enableAdditionalBrandNumericCode && brand.numeric_code ? ` (${brand.numeric_code})` : ""}`}
      />
      {!!brand?.archived_at && (
        <span style={{ marginLeft: 8 }}>
          <Badge colorScheme="blue">
            <Trans>Archived</Trans>
          </Badge>
        </span>
      )}
    </div>
  );
};

export default observer(BrandTitle);
